var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "0AE6D54F-459F-4C63-9058-2CFA8CD67772")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customer-statements---add-payment-copy-2",
    transform: "translate(-202.000000, -272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sales-rep-options",
    transform: "translate(64.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(16.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(116.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new_icon-copy",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#3796F6",
    cx: 6,
    cy: 6,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59375,6.69140625 L6.59375,2.73828125 L5.41015625,2.73828125 L5.41015625,6.69140625 L6.59375,6.69140625 Z M6.62109375,9.05 L6.62109375,7.8 L5.3828125,7.8 L5.3828125,9.05 L6.62109375,9.05 Z",
    id: "!",
    fill: "#3796F6",
    fillRule: "nonzero"
  })))))))));
};

export default __webpack_public_path__ + "static/media/new.1026a30c.svg";
export { SvgComponent as ReactComponent };